import { find } from "lodash";
import { useCurrentProject } from "@radarly/core/project/use-cases";
import { useCurrentUserProjects } from "@radarly/core/user/use-cases";

export function useContextualProjectUserData() {
  const projects = useCurrentUserProjects();
  const project = useCurrentProject();
  return project ? find(projects, { id: project.id }) : null;
}
